/**
 * @Author: Cecilia López Martinez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
import { useDispatch } from "react-redux"; // Import Redux dispatch to trigger actions
import {
    SearchByFilters, // Import action for searching by filters
    SearchByFiltersCustom, // Import action for custom search by filters
    SimpleSearch, // Import action for simple search
    SimpleSearchWithId // Import action for simple search with contractor ID
} from "../../../../reduxToolkit/Search/SearchApi"; // Import Redux search API actions
import { CRITERIA_MODEL, SEARCH_MODEL } from "../../../../components/table/Model/TableModel"; // Import criteria and search models
import { VIEW_TYPE } from '../../../../enums/ViewType'; // Import React hook to manage side effects

// Main component for handling contract data
const ContractDataApp = (
    {
        searchElement,
        contractorId,
        setCriteria,
        setBodyForExport,
        setResults,
        option,
        finalArray,
        viewType = VIEW_TYPE.LIST.viewType
    }
) => {

    const dispatch = useDispatch();

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { rowsPerPage }) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            key: searchElement,
            model: option,
            viewType,
            ...(contractorId && { userId: contractorId }),
        });
        setBodyForExport(body);
        const action = contractorId ? SimpleSearchWithId : SimpleSearch;
        dispatch(action({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setResults(data);
        });
    };

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page, { rowsPerPage }) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            viewType,
            ...(contractorId && { userToFindId: contractorId }),
        });
        setCriteria(body);
        const action = contractorId ? SearchByFiltersCustom : SearchByFilters;
        dispatch(action({ option, body })).then(({ payload: { data: { data } } }) => {
            setResults(data);
        });
    };

    return {
        getData,
        getDataAdvancedSearch
    }

}

export default ContractDataApp; // Export the component to be used in other parts of the app
